import type {
  FeatureFlagClientConfigurationMap,
  FeatureFlagConfirmationType,
  FeatureFlagConfirmationTone,
  FeatureFlagTargetClient,
  FeatureFlagTargetClientOption,
} from '../../../types/features/featureFlags';

export const FEATURE_FLAG_CLIENT_OPTIONS: FeatureFlagTargetClientOption[] = [
  {
    helperText: 'Configure Web App rollout separately.',
    label: 'Web App',
    value: 'webapp',
  },
  {
    helperText: 'Configure Mobile App rollout separately.',
    label: 'Mobile App',
    value: 'mobile_app',
  },
];

export const FEATURE_FLAG_CLIENT_LABELS: Record<FeatureFlagTargetClient, string> = {
  mobile_app: 'Mobile App',
  webapp: 'Web App',
};

export const FEATURE_FLAG_CONFIRMATION_COPY: Record<FeatureFlagConfirmationType, {
  confirmButtonText: string;
  confirmTone: FeatureFlagConfirmationTone;
  messageTemplate: string;
  title: string;
}> = {
  global_off: {
    confirmButtonText: 'Disable Globally',
    confirmTone: 'danger',
    messageTemplate: 'This will turn off the feature for {clientLabel}.',
    title: 'Disable Global State?',
  },
  global_on: {
    confirmButtonText: 'Enable Global State',
    confirmTone: 'primary',
    messageTemplate: 'This will enable the feature for all stores and users for {clientLabel}.',
    title: 'Enable Global State?',
  },
};

export const createEmptyFeatureClientConfigurations = (
  selectedClient: FeatureFlagTargetClient = 'webapp',
): FeatureFlagClientConfigurationMap => ({
  mobile_app: {
    assignmentTarget: 'store_wise',
    globalEnabled: false,
    selected: selectedClient === 'mobile_app',
    storeIds: [],
    userIds: [],
  },
  webapp: {
    assignmentTarget: 'store_wise',
    globalEnabled: false,
    selected: selectedClient === 'webapp',
    storeIds: [],
    userIds: [],
  },
});
